import * as Yup from "yup";

export const AddOfflineTransactionSchema = Yup.object().shape({
  transaction_amount: Yup.string().required("Transaction amount is required"),
  transaction_type: Yup.string().required("Transaction type is required"),
  admin_account_number: Yup.string().required("Number is required"),
});
